import { apiClient } from './api';
import {
  ApiKey,
  CreateApiKeyRequest,
  CreateApiKeyResponse,
  ToggleApiKeyRequest,
} from '../types/api';

export const apiKeyService = {
  getAll: async (): Promise<ApiKey[]> => {
    const { data } = await apiClient.get('/apikeys');
    return data;
  },

  getById: async (id: number): Promise<ApiKey> => {
    const { data } = await apiClient.get(`/apikeys/${id}`);
    return data;
  },

  create: async (request: CreateApiKeyRequest): Promise<CreateApiKeyResponse> => {
    const { data } = await apiClient.post('/apikeys', request);
    return data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/apikeys/${id}`);
  },

  toggleStatus: async (id: number, isActive: boolean): Promise<void> => {
    await apiClient.patch(`/apikeys/${id}/toggle`, { isActive } as ToggleApiKeyRequest);
  },
};
